export default "__VITE_ASSET__Da$Mk1ie__"